import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Button from '../../components/Button/Button';
import Header from '../../components/Header/Header';

import translate from '../../libs/i18n';

import notFoundIllustration from '../../assets/images/healthscan-not-found-illustration.svg';

import { NotFoundStyle } from '../NotFound/NotFoundStyle';

const NotFoundAdmin = () => {
  const language = useSelector((state) => state.settings.language);

  return (
    <NotFoundStyle>
      <Header />
      <div className="not-found-container">
        <div className="not-found-text-content">
          <h1 className="not-found-title">
            {translate('pageNotFound', language)}
          </h1>
          <div className="not-found-instruction">
            <p>
              {`${translate('typedAddressIncorrectly', language)}. ${translate(
                'dontWorryYouCanGoTo',
                language
              )} `}
              <Link to="/">{translate('panelControl', language)}</Link>
              {` ${translate('toGetBackToNavigation', language)}.`}
            </p>
            <p>
              {`${translate('ifYouNeedSupportGoToThe', language)} `}
              <Link to="/ajuda">{translate('helpPage', language)}</Link>
              {` ${translate('andGetInTouchWithUs', language)}.`}
            </p>
          </div>
          <div className="go-to-button-wrapper">
            <Button
              type="link"
              theme="default"
              size="default"
              text={translate('goToExamsPanel', language)}
              to="/"
            />
          </div>
        </div>
        <div className="not-found-image-content">
          <div className="logo-wrapper">
            <img
              className="not-found-illustration"
              src={notFoundIllustration}
              alt="Login illustration"
            />
          </div>
        </div>
      </div>
    </NotFoundStyle>
  );
};

export default NotFoundAdmin;
